import { NotificationResources } from '../types/notification';

export const getSherpaRoutes = ({ resourceType, resourceTypeId, meta }: IGetPlatformRoutes): string => {
  switch (resourceType) {
    case NotificationResources.Approval: {
      if (meta.refId && meta.refType) {
        return `/terminal/dashboard/${meta.refType.toString().toLowerCase()}s/${meta.refId}`;
      } else {
        return '/app/sherpa/projects';
      }
    }
    case NotificationResources.Application: {
      return `/app/rover/application_forms/${meta.applicationFormId}/applications/${resourceTypeId}/application_details`;
    }
    case NotificationResources.Deliverable:
      return `/terminal/dashboard/deliverables/${resourceTypeId}`;
    case NotificationResources.DeliverableComment:
      return `/terminal/dashboard/deliverables/${meta.tdmId}`;
    case NotificationResources.Milestone:
      return `/terminal/dashboard/milestones/${resourceTypeId}`;
    case NotificationResources.MilestoneComment:
      return `/terminal/dashboard/milestones/${meta.tdmId}`;
    case NotificationResources.Project:
      return `/app/sherpa/projects/${resourceTypeId}/dashboard`;
    case NotificationResources.Schedule: {
      if (meta.projectId && meta.type) {
        return `/app/sherpa/projects/${meta.projectId}/${meta.type}`;
      } else {
        return '/app/sherpa/projects';
      }
    }
    case NotificationResources.Task:
      return `/terminal/dashboard/tasks/${resourceTypeId}`;
    case NotificationResources.TaskComment:
      return `/terminal/dashboard/tasks/${meta.tdmId}`;
    default:
      throw new Error('resource type not recognized for sherpa app');
  }
};
